import {
  createBrowserRouter,
  Route,
  Link,
  NavLink,
  createRoutesFromElements,
  RouterProvider
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";

import Header from './components/header/Header'


//pages
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import TodoList from "./pages/TodoList";

import BlogPosts, { blogPostsLoader } from "./blog/BlogPosts";
import TSin100Days from "./ts100Days/TSin100Days";
import Contact from "./components/contact/Contact";
import NotFound from "./pages/notFound/NotFound";
import IndividualBlogPost from "./pages/blogPosts/IndividualBlogPost";

//layouts
import RootLayout from "./layouts/RootLayout";
import BlogLayout from "./layouts/BlogLayout";

const router = createBrowserRouter(
  createRoutesFromElements(

    <Route path="/" element={<RootLayout />} >
        <Route index element={<Home />} />

        {/* <Route path="about" element={<About />}>
  <Route path="contact" element={<Contact />} />
</Route> */}

        <Route path="blog" element={<BlogLayout />}>
          <Route
            index
            element={<BlogPosts />}
          />

        </Route>

        <Route path="post/:id" element={<IndividualBlogPost />} />

        {/* <Route path="todolist" element={<TodoList />} /> */}

        <Route path="*" element={<NotFound />} />
    </Route>

  )
)

const App = () => {
  return (
    <RouterProvider router={router} />
  );
}

export default App